export default {"src":"/_next/static/media/logo__chrono-black.a927476a.svg","height":161,"width":923,"blurWidth":0,"blurHeight":0};